// ============================================
// COMPOSANTS UI STYLE WINFORMS
// ============================================

export const WinButton = ({ children, onClick, icon, IconComponent, active, disabled, title, "data-testid": testId }) => (
  <button 
    className={`win-toolbar-btn ${active ? 'active' : ''}`} 
    onClick={onClick} 
    disabled={disabled}
    title={title}
    data-testid={testId}
  >
    {IconComponent ? (
      <span className="win-btn-icon"><IconComponent size={20} strokeWidth={1.75} /></span>
    ) : icon ? (
      <span className="win-btn-icon">{icon}</span>
    ) : null}
    <span className="win-btn-label">{children}</span>
  </button>
);

export const WinInput = ({ label, value, onChange, type = "text", placeholder, width, disabled, readOnly, className = "", style = {}, ...props }) => (
  <input 
    type={type}
    className={`win-input ${className} ${readOnly ? 'win-input-readonly' : ''}`}
    value={value || ''}
    onChange={e => !readOnly && onChange && onChange(e.target.value)}
    placeholder={placeholder}
    style={{ ...(width ? { width } : {}), ...style }}
    disabled={disabled}
    readOnly={readOnly}
    {...props}
  />
);

export const WinSelect = ({ value, onChange, options, width, disabled }) => (
  <select 
    className="win-select"
    value={value || ''}
    onChange={e => onChange && onChange(e.target.value)}
    style={width ? { width } : {}}
    disabled={disabled}
  >
    {options.map(opt => (
      <option key={opt.value} value={opt.value}>{opt.label}</option>
    ))}
  </select>
);

export const WinCheckbox = ({ label, checked, onChange, disabled, ...rest }) => (
  <label className="win-checkbox">
    <input 
      type="checkbox" 
      checked={checked || false}
      onChange={e => onChange && onChange(e.target.checked)}
      disabled={disabled}
      {...rest}
    />
    {label}
  </label>
);

export const WinRadio = ({ name, value, checked, onChange, label }) => (
  <label className="win-radio">
    <input 
      type="radio" 
      name={name}
      value={value}
      checked={checked}
      onChange={e => onChange && onChange(e.target.value)}
    />
    {label}
  </label>
);

export const WinFieldRow = ({ label, children, labelWidth = 150 }) => (
  <div className="win-field-row">
    <label className="win-field-label" style={{ width: labelWidth }}>{label}</label>
    <div className="win-field-content">{children}</div>
  </div>
);

export const WinSectionHeader = ({ children }) => (
  <div className="win-section-header">{children}</div>
);

export const WinGroupBox = ({ title, children }) => (
  <fieldset className="win-groupbox">
    <legend>{title}</legend>
    {children}
  </fieldset>
);
